import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import './index.scss'
import { getStorage,gotonext} from "@/utils";
import {savedata, savebasedata} from "../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal} from "antd";
import {dpeallcitylist} from "../../../../utils/citylist";
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {getbaseInfo} from "../../../../servers/menuAPI";
import {dpeprovincelist, dpeselectmap} from "../../../../utils/dpedatadef";
@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.computeddata = this.computeddata.bind(this)
    this.computeddata1 = this.computeddata1.bind(this)
    this.onChange = this.onChange.bind(this)
  }


  state = {
    data: storeManageListNewData,
    appform:''
  }

  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
        if (item.id === data.id){
          item.ifEdit = !item.ifEdit
          if (data.hasupload!== '') {
            d.forEach(item1=>{
              if (item1.id === data.hasupload){
                item1.ifEdit = !item1.ifEdit
              }
            })
          }
        }
      })
    this.setState({
      data:result
    })
  }

  onChange(data){
    if (data.data.id === 'provinceid'){
     const arr = this.computeddata(data.value)
      const params = JSON.parse(JSON.stringify(this.state.data))
      params[0].data[16].options = arr
      params[0].data[17].options = []
      params[0].data[16].value = ''
      params[0].data[17].value = ''
      params[0].data[15].value = data.value
      this.setState({
        data:params
      })
    }
    if (data.data.id === 'regionid'){
      const arr = this.computeddata2(this.state.data[0].data[15].value,data.value)
      const params = JSON.parse(JSON.stringify(this.state.data))
      params[0].data[17].options = arr
      if (arr.length === 0) {
        params[0].data[17].value = ''
      } else {
        params[0].data[17].value = ''
      }
      params[0].data[16].value = data.value
      this.setState({
        data:params
      })
    }
  }

  computeddata(d){
    let str = []
    dpeallcitylist.forEach(item=>{
        if (Number(item.id) === Number(d)){
          str = item.children
        }
    })
    return str
  }

  computeddata2(d,d1){
    let str = []
    dpeallcitylist.forEach(item=>{
      if (Number(item.id) === Number(d)){
        item.children.forEach(item2=>{
          if (item2.id === d1){
            if (item2.children.length === 1 && item2.children[0].name === '' && item2.children[0].id === ''){
              str = []
            } else {
              str = item2.children
            }
          }
        })
      }
    })
    return str
  }

  computeddata1(type){
    const arr =dpeselectmap[type]
    return arr
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      museumid:getStorage('userList').museumid,
      extra:true
    }
    getbaseInfo(params).then(res=>{
      if (res.statecode === 0 && res.records.length >0) {
        if (res.records[0].pagetips) {
          const data = this.state.data
          data[0].pagetips = res.records[0].pagetips
          this.setState({
            data:data
          })
        } else {
          const data = this.state.data
          data[0].pagetips = ''
          this.setState({
            data:data
          })
        }
        const data = []
        for (let i=0;i<34;i++){
          const obj = {}
          obj.id = ''
          obj.name =''
          obj.placeholder=''
          obj.type= 'input'
          obj.checkType= 'required'
          obj.newDisabled=false
          obj.editDisabled=false
          obj.newShow= true
          obj.editShow=true
          obj.ifEdit= false
          obj.value= ''
          obj.options=[]
          obj.expand = {
            autosize: {minRows: 4, maxRows: 10}
          }
          obj.hasupload = ''
          obj.jpath = ''
          obj.tips =''
          obj.showeditbtn = false
          data.push(obj)
        }

        data[0].id = 'name'
        data[0].jpath = 'name'
        data[0].name = '博物馆名称'
        data[0].value = res.records[0].name
        data[0].newDisabled=true
        data[0].editDisabled=true

        data[1].id = 'levelid'
        data[1].jpath = 'levelid'
        data[1].name = '质量等级'
        data[1].type= 'select'
        data[1].value = res.records[0].levelid
        data[1].options= this.computeddata1('14')
        data[1].newDisabled=true
        data[1].editDisabled=true
        data[1].disabled=true

        data[2].id = 'natureid'
        data[2].jpath = 'natureid'
        data[2].type= 'select'
        data[2].name = '博物馆性质'
        data[2].value = res.records[0].natureid
        data[2].options= this.computeddata1('13')

        data[3].id = 'corporateid'
        data[3].jpath = 'corporateid'
        data[3].type= 'select'
        data[3].name = '法人类型'
        data[3].value = res.records[0].corporateid
        data[3].options= this.computeddata1('1C')

        data[4].id = 'socialcode'
        data[4].jpath = 'socialcode'
        data[4].name = '统一社会信用代码'
        data[4].value = res.records[0].socialcode

        data[5].id = 'regauthority'
        data[5].jpath = 'regauthority'
        data[5].name = '法人登记机关'
        data[5].value = res.records[0].regauthority

        data[6].id = 'subjectid'
        data[6].jpath = 'subjectid'
        data[6].type= 'select'
        data[6].name = '题材类型'
        data[6].value = res.records[0].subjectid
        data[6].options= this.computeddata1('17')

        data[7].id = 'holder'
        data[7].jpath = 'holder'
        data[7].name = '举办者'
        data[7].value = res.records[0].holder

        data[8].id = 'belonglevelid'
        data[8].jpath = 'belonglevelid'
        data[8].type= 'select'
        data[8].name = '隶属层级'
        data[8].value = res.records[0].belonglevelid
        data[8].options= this.computeddata1('1B')

        data[9].id = 'legalman'
        data[9].jpath = 'legalman'
        data[9].name = '法定代表人'
        data[9].value = res.records[0].legalman

        data[10].id = 'createdate'
        data[10].jpath = 'createdate'
        data[10].name = '设立时间'
        data[10].type= 'date'
        data[10].value = res.records[0].createdate

        data[11].id = 'firstdate'
        data[11].jpath = 'firstdate'
        data[11].name = '开馆日期'
        data[11].type= 'date'
        data[11].value = res.records[0].firstdate

        data[12].id = 'openperiod'
        data[12].jpath = 'openperiod'
        data[12].name = '开放时间'
        data[12].value = res.records[0].openperiod




        data[13].id = 'freeopenid'
        data[13].jpath = 'freeopenid'
        data[13].type= 'select'
        data[13].name = '免费开放'
        data[13].value = res.records[0].freeopenid
        data[13].options= this.computeddata1('1A')

        data[14].id = 'centralsubsidyid'
        data[14].jpath = 'centralsubsidyid'
        data[14].type= 'select'
        data[14].name = '是否纳入中央补助免费开放博物馆纪念馆名单'
        data[14].value = res.records[0].centralsubsidyid
        data[14].options= this.computeddata1('1M')

        data[15].id = 'provinceid'
        data[15].jpath = 'provinceid'
        data[15].name = '行政区划'
        data[15].value = res.records[0].provinceid
        data[15].type= 'select'
        data[15].options= dpeprovincelist


        data[16].id = 'regionid'
        data[16].jpath = 'regionid'
        data[16].value = res.records[0].regionid
        data[16].type= 'select'
        data[16].placeholder= '请选择'
        data[16].options= this.computeddata(res.records[0].provinceid)


        data[17].id = 'cityid'
        data[17].jpath = 'cityid'
        data[17].value = res.records[0].cityid
        data[17].type= 'select'
        data[17].placeholder= '请选择'
        data[17].options= this.computeddata2(res.records[0].provinceid,res.records[0].regionid)
        data[17].checkType = ''

        data[18].id = 'address'
        data[18].jpath = 'address'
        data[18].name = '馆舍地址'
        data[18].value = res.records[0].address

        data[19].id = 'addresslon'
        data[19].jpath = 'addresslon'
        data[19].name = '馆址经度'
        data[19].value = res.records[0].addresslon

        data[20].id = 'addresslat'
        data[20].jpath = 'addresslat'
        data[20].name = '馆址纬度'
        data[20].value = res.records[0].addresslat



        data[21].id = 'postcode'
        data[21].jpath = 'postcode'
        data[21].name = '邮政编码'
        data[21].value = res.records[0].postcode

        data[22].id = 'equityid'
        data[22].jpath = 'equityid'
        data[22].type= 'select'
        data[22].name = '馆舍产权性质'
        data[22].value = res.records[0].equityid
        data[22].options= this.computeddata1('19')

        data[23].id = 'buildingnatureid'
        data[23].jpath = 'buildingnatureid'
        data[23].type= 'select'
        data[23].name = '馆舍建筑性质'
        data[23].value = res.records[0].buildingnatureid
        data[23].options= this.computeddata1('18')

        data[24].id = 'nationalreserve'
        data[24].jpath = 'nationalreserve'
        data[24].name = '国保单位名称'
        data[24].type = 'input'
        data[24].value = res.records[0].nationalreserve
        data[24].checkType = ''


        data[25].id = 'nationalreserveno'
        data[25].jpath = 'nationalreserveno'
        data[25].name = '国保单位批次'
        data[25].value = res.records[0].nationalreserveno
        data[25].type= 'number'
        data[25].zhengshu1 = true
        data[25].checkType = ''


        data[26].id = 'roomarea'
        data[26].jpath = 'roomarea'
        data[26].name = '馆舍建筑面积m²'
        data[26].value = res.records[0].roomarea
        data[26].tips = '仅允许输入整数数字'
        data[26].type = 'number'
        data[26].zhengshu1 = true



        data[27].id = 'showarea'
        data[27].jpath = 'showarea'
        data[27].name = '展厅面积m²'
        data[27].value = res.records[0].showarea
        data[27].tips = '仅允许输入整数数字'
        data[27].type = 'number'
        data[27].zhengshu1= true

        data[28].id = 'storearea'
        data[28].jpath = 'storearea'
        data[28].name = '库房面积m²'
        data[28].value = res.records[0].storearea
        data[28].tips = '仅允许输入整数数字'
        data[28].type = 'number'
        data[28].zhengshu1 = true

        data[29].id = 'repairarea'
        data[29].jpath = 'repairarea'
        data[29].name = '实验修复面积m²'
        data[29].value = res.records[0].repairarea
        data[29].tips = '仅允许输入整数数字'
        data[29].type = 'number'
        data[29].zhengshu1 = true

        data[30].id = 'teacharea'
        data[30].jpath = 'teacharea'
        data[30].name = '教育空间面积m²'
        data[30].value = res.records[0].teacharea
        data[30].tips = '仅允许输入整数数字'
        data[30].type = 'number'
        data[30].zhengshu1 = true

        data[31].id = 'publicarea'
        data[31].jpath = 'publicarea'
        data[31].name = '公共服务面积m²'
        data[31].value = res.records[0].publicarea
        data[31].tips = '仅允许输入整数数字'
        data[31].type = 'number'
        data[31].zhengshu1 = true

        data[32].id = 'repairqualificationid'
        data[32].jpath = 'repairqualificationid'
        data[32].name = '可移动文物修复资质'
        data[32].type = 'select'
        data[32].value = res.records[0].repairqualificationid
        data[32].options = this.computeddata1('1N')

        data[33].id = 'repairqualificationdate'
        data[33].jpath = 'repairqualificationdate'
        data[33].name = '取得可移动文物修复资质的年份'
        data[33].value = res.records[0].repairqualificationdate
        data[33].checkType = ''

          const d = JSON.parse(JSON.stringify(this.state.data))
          d[0].data = data
        this.setState({
            data:d,
            appform:res.records[0].appform
        })
      } else {
        message.error('未查询到博物馆信息');
      }
    })
  }


  onSubmit(data){
    if (data.data.socialcode.length > 18) {
      message.error('统一社会信用代码限定“18位长”');
      return false
    }
    var regex = /^[a-zA-Z0-9]+$/;
    var inputVal = data.data.socialcode;
    if (!regex.test(inputVal)) {
      message.error('统一社会信用代码仅能输入数字和字母');
      return false
    }
    if (data.data.nationalreserveno !=='' && !(/^\d+$/.test(data.data.nationalreserveno))){
      message.error('国保单位批次为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.roomarea))){
      message.error('馆舍建筑面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.showarea))){
      message.error('展厅面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.storearea))){
      message.error('库房面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.repairarea))){
      message.error('实验修复面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.teacharea))){
      message.error('教育空间面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.publicarea))){
      message.error('公共服务面积为整数')
      return false
    }
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler(data)
      }
    })
  }
  //下一步
  onCancel(data){
    console.log(data);
    if (data.data.socialcode.length > 18) {
      message.error('统一社会信用代码限定“18位长”');
      return false
    }
    var regex = /^[a-zA-Z0-9]+$/;
    var inputVal = data.data.socialcode;
    if (!regex.test(inputVal)) {
      message.error('统一社会信用代码仅能输入数字和字母');
      return false
    }
    if (data.data.nationalreserveno !=='' && !(/^\d+$/.test(data.data.nationalreserveno))){
      message.error('国保单位批次为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.roomarea))){
      message.error('馆舍建筑面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.showarea))){
      message.error('展厅面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.storearea))){
      message.error('库房面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.repairarea))){
      message.error('实验修复面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.teacharea))){
      message.error('教育空间面积为整数')
      return false
    }
    if (!(/^\d+$/.test(data.data.publicarea))){
      message.error('公共服务面积为整数')
      return false
    }
    Modal.confirm({
      content: '确认提交数据到下一个填报页面?',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        this.onSubmitHandler(data,'tz')
      }
    })
  }

  onSubmitHandler(data, type=''){
    if (data.status){
      for (let key in data.data) {
        if (typeof data.data[key] !== 'string' && typeof data.data[key] !== 'number'){
          delete data.data[key]
        }
      }
      const params = JSON.parse(JSON.stringify(data.data))
      params.annual = localStorage.getItem('year')
      if (params.cityid === '-999999'){
        params.cityid = ''
      }
      savebasedata(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
           if (type === 'tz'){
            gotonext()
            this.props.history.push({
              pathname: '/informationDeclaration/standardManage/organization/legal',
            });
          }
        } else {
          message.error(res.statemessage,2,()=>{
            if (type === 'tz'){
              gotonext()
              this.props.history.push({
                pathname: '/informationDeclaration/standardManage/organization/legal',
              });
            }
          });
        }
      })
    }
  }

  componentDidMount(){
    this.onSelect()
  }

  downloads(file){
    window.location.href = file
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        {this.state.appform && this.state.appform!=='' &&
            <div className='shenhe-item' style={{color:'#1e9fff',textAlign:'right',fontSize:'16px',fontWeight:'bold',cursor:'pointer'}} onClick={()=>{this.downloads(this.state.appform)}}>
              运行评估申报书
            </div>
        }
        <CPageNew
            data={this.state.data}
            onChange={this.onChange}
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
            onChangeEdit={this.onChangeEdit}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

